import cn from 'classnames'
import { FC } from 'react'
import { PortalAccountDomain } from '../../../utils/enums'
import { useAppState } from '../../../utils/hooks'
import Image from '../Image'
import styles from './style.module.scss'

interface AppLogoProps {
  className?: string
}

const AppLogo: FC<AppLogoProps> = ({ className }) => {
  const { portalAccountDomain } = useAppState()
  const ja = portalAccountDomain === PortalAccountDomain.TMJP
  return (
    <Image
      name={ja ? 'jpLogo' : 'tmLogo'}
      className={cn(styles['app-logo'], className)}
    />
  )
}


export default AppLogo
